import React from 'react'
import { hot } from 'react-hot-loader'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-quill/dist/quill.snow.css';

import { AppRouter } from './AppRouter'
import { SlotPortalProvider } from './Components/Portal'
import { DimensionsProvider } from './utils/dimensions-context'
import { ThemeProvider } from './Components/ThemeSwitcher'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()
// eslint-disable-next-line functional/no-class
class App_ extends React.Component<
  Record<string, never>,
  Record<string, never>
> {
  render(): JSX.Element {
    return (
      <DimensionsProvider>
        <SlotPortalProvider>
          <ThemeProvider>
            <QueryClientProvider client={queryClient}>
              <AppRouter />
            </QueryClientProvider>
          </ThemeProvider>
        </SlotPortalProvider>
      </DimensionsProvider>
    )
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const module: any

// Only use hot module replacement in development mode
// Check for both NODE_ENV and a custom DISABLE_HOT_LOADER flag
const isDevelopment = process.env.NODE_ENV !== 'production' && !process.env.DISABLE_HOT_LOADER

if (isDevelopment && module.hot) {
  module.hot.accept()
}

// Only apply hot loader in development mode
export const App = isDevelopment ? hot(module)(App_) : App_
